import { mapEmojis } from '../../helpers';

import baseEmojis from './emojis.json';

export default mapEmojis(baseEmojis, 'Animals & Nature');
